import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { readCurriculumAction, updateCurriculumAction } from '../../store/Languages/LanguageAction';
import {churchCurriculumSaveAction} from "../../store/Curriculum/CurriculumAction.js"
import CurriculumCard from './CurriculumCard';
import Modal from './Modal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from "react-router-dom";
import AllCurriculum from "../../screens/Curriculum/AllCurriculum.js"
import {fetchChurchesRequest} from "../../store/Churches/actions.js"
import { deleteCurriculumAction } from "../../store/Languages/LanguageAction";
import CurriculumModal from "../Curriculum/CurriculumModal.js"
import {churchCurriculumDeleteAction} from "../../store/Curriculum/CurriculumAction.js"
import CustomTable from '../../components/universal/CustomTable.js';
import ConfirmToast from '../../components/universal/ConfirmToast.js';
import { confirmAlert } from 'react-confirm-alert';
const CurriculumList = ({ church, typeofentity }) => {
  const dispatch = useDispatch();

  const [allCurriculums, setAllCurriculums] = useState([]);
  const [selectedCurriculums, setSelectedCurriculums] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const location = useLocation();
  const [churchCurriculums, setChurchCurriculums] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [editingCurriculum, setEditingCurriculum] = useState(null);

  /** Fetch all curriculums once */
  useEffect(() => {
    fetchCurriculums();
  }, []);
  const getEntityKey = (type) => {
    if (Number(type) === 2) return "channelObjId";
    if (Number(type) === 3) return "ministriesObjId";
    return "_id";
  };

  useEffect(() => {
    if (!church?._id) return;
    dispatch(
      fetchChurchesRequest({
        apiPayloadRequest: {
          _id: church?._id, // optional — read all churches
          typeofentity: typeofentity || 1,
        },
        callback: (res) => {
                    setChurchCurriculums(res?.data?.[0]?.curriculums)
        },
      })
    );
  }, [church?._id, typeofentity]);
  const fetchCurriculums = () => {
    setLoading(true);
    dispatch(
      readCurriculumAction({
        callback: (res) => {
          if (res.type === 1 && res.data) {
                        setAllCurriculums(res.data);
          }
          setLoading(false);
        },
      })
    );
  };
  const handleEditCurriculum = (curriculum) => {
    setEditingCurriculum(curriculum);
    setIsEditModalOpen(true);
  };

  const handleDeleteCurriculum = (curriculum) => {
    if (!window.confirm("Are you sure you want to delete this curriculum?")) return;
        dispatch(
      churchCurriculumDeleteAction({
        apiPayloadRequest: {
          churchcurriculumObjId: curriculum._id,
          [getEntityKey(typeofentity)]: church?._id
        },
        callback: (res) => {
          if (res?.type === 1) {
            toast.success("Curriculum Deleted Successfully!");

            // remove from UI instantly
            setChurchCurriculums((prev) =>
              prev.filter((item) => item._id !== curriculum._id)
            );
          } else {
            toast.error("Curriculum Failed To Delete!");
          }
        },
      })
    );
  };

  /** Add curriculum from modal to selected list */
  const handleSelectCurriculum = (curriculum) => {
    setSelectedCurriculums((prev) => {
      const alreadyExists = prev.some((item) => item._id === curriculum._id);
      if (alreadyExists) return prev;
      return [...prev, curriculum];
    });
    setIsModalOpen(false);
  };

  /** Save selected curriculums using React-Toastify for notifications */
  /** Save selected curriculums and refresh church curriculums */
const handleSaveSelected = async () => {
  if (selectedCurriculums.length === 0) return;

  setSaving(true);

  try {
    await Promise.all(
      selectedCurriculums.map(
        (curriculum) =>
          new Promise((resolve, reject) => {
            dispatch(
              churchCurriculumSaveAction({
                apiPayloadRequest: {
                  [getEntityKey(typeofentity)]: church?._id,                 // Church/Channel/Ministry Obj Id
                  curriculumObjId: curriculum._id,  // Curriculum Obj Id
                },
                callback: (resp) => {
                  if (resp?.type === 1) {
                    toast.success(
                      `"${curriculum.curriculum_name}" saved successfully!`
                    );
                    resolve(resp);
                  } else {
                    toast.error(
                      `Failed to save "${curriculum.curriculum_name}"`
                    );
                    reject(new Error("Failed to save curriculum"));
                  }
                },
              })
            );

          })
      )
    );

    toast.success("All selected curriculums saved successfully!");
    setSelectedCurriculums([]); // optionally clear selection

    // ✅ Refresh church curriculums
    if (church?._id) {
      dispatch(
        fetchChurchesRequest({
          apiPayloadRequest: {
            _id: church._id,
            typeofentity: typeofentity || 1
          },
          callback: (res) => {
            if (res?.type === 1) {
              const churchData = res?.data?.[0];
              setChurchCurriculums(churchData?.curriculums || []);
            }
          },
        })
      );
    }
  } catch (error) {
      } finally {
    setSaving(false);
  }
};
const curriculumTableHeaders = [
  { headerName: "Curriculum Name", headerId: "curriculum_name", width: "w-48" },
  { headerName: "Description", headerId: "description", width: "w-64" },
  { headerName: "Created Date", headerId: "createdDate", width: "w-40" },
  { headerName: "Actions", headerId: "actions", width: "w-32" },
];
const transformCurriculumTableData = (data = []) => {
  return data.map((item) => ({
    ...item,

    curriculum_name:
      typeof item.curriculum_name === "string"
        ? item.curriculum_name
        : "Untitled",

    description:
      typeof item.description === "string"
        ? item.description
        : "No description",

    createdDate:
      item.createdDate && typeof item.createdDate === "string"
        ? new Date(item.createdDate).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })
        : "N/A",

    // 🔥 IDs for actions (NOT rendered)
    churchCurriculumObjId: item._id,
    churchId: church?._id,
    typeofentity: typeofentity
  }));
};



  return (
    <>
    <AllCurriculum church={church} selectedCurriculums={selectedCurriculums}/>
    {
      church?
    <div className="container mx-auto px-4 py-8">
      {/* ToastContainer */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-xl font-bold text-gray-400">Selected Curriculums</h1>
<div className='flex items-center gap-4'>
        <button
          onClick={() => setIsModalOpen(true)}
          className="text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
        >
          Add Curriculum
        </button>
        {selectedCurriculums.length > 0 && (
        <div className="text-center">
          <button
            onClick={handleSaveSelected}
            disabled={saving}
            className="text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
          >
            {saving ? "Saving..." : "Save Selected Curriculums"}
          </button>
        </div>
      )}
      </div>
      </div>

      {/* Selected Curriculum List */}
      {selectedCurriculums?.length === 0 ? (
        <p className="text-gray-500 text-center py-10">No curriculum selected</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-4">
          {selectedCurriculums.map((curriculum) => (
            <CurriculumCard key={curriculum._id} curriculum={curriculum} onClick={() => {}} />
          ))}
        </div>
      )}
<h1 className="text-xl font-bold text-gray-400 mb-4">
  Church Curriculums
</h1>

{churchCurriculums?.length === 0 ? (
  <p className="text-gray-500 text-center py-6">
    No curriculums added to this church
  </p>
) : (


<>
<CustomTable
  searchFor="Curriculums"
  heightDesktop="h-[60vh]"
  width="w-full"
  headers={curriculumTableHeaders}
  data={transformCurriculumTableData(churchCurriculums)}
  dataTransformer={transformCurriculumTableData}
  customDataFetch={false}
  reloadData={false}
  reverseTable={false}
  showSearch={true}
  searchPlaceholder="Search curriculums..."
  emptyStateMessage="No curriculums added to this church"

  handleEditClick={(row) => {
    setEditingCurriculum(row);
    setIsEditModalOpen(true);
  }}

  handleDeleteClick={(row) => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <ConfirmToast
          title="Delete Curriculum"
          message={`Are you sure you want to delete "${row.curriculum_name}"? This action cannot be undone.`}
          onClose={onClose}
          onSuccess={() => {
            dispatch(
              churchCurriculumDeleteAction({
                apiPayloadRequest: {
                  [getEntityKey(row.typeofentity)]: row.churchId,
                  churchcurriculumObjId: row.churchCurriculumObjId,
                },
                callback: (res) => {
                  if (res?.type === 1) {
                    toast.success("Curriculum deleted successfully!");

                    // 🔥 Update UI instantly
                    setChurchCurriculums((prev) =>
                      prev.filter(
                        (item) => item._id !== row.churchCurriculumObjId
                      )
                    );
                  } else {
                    toast.error("Failed to delete curriculum!");
                  }
                  onClose();
                },
              })
            );
          }}
        />
      ),
    });
  }}
/>
</>
)}

      {/* Save button */}
      {/* {selectedCurriculums.length > 0 && (
        <div className="text-center mb-8">
          <button
            onClick={handleSaveSelected}
            disabled={saving}
            className="px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors duration-300"
          >
            {saving ? "Saving..." : "Save Selected Curriculums"}
          </button>
        </div>
      )} */}

      {/* Modal showing ALL curriculums */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="space-y-6">
          <h2 className="text-xl font-bold text-gray-400">Select Curriculum</h2>

          {loading ? (
            <div className="flex justify-center py-10">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600" />
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {allCurriculums.map((curriculum) => (
                <CurriculumCard
                  key={curriculum._id}
                  curriculum={curriculum}
                  onClick={handleSelectCurriculum}
                />
              ))}
            </div>
          )}
        </div>
      </Modal>
    </div>
    :
    <div className="w-full h-full flex items-center justify-center text-gray-400 ">
    <p>Add {Number(typeofentity) === 2 ? 'Channel' : Number(typeofentity) === 3 ? 'Ministry' : 'Church'} First</p>
    </div>
}
<CurriculumModal
  isOpen={isEditModalOpen}
  onClose={() => {
    setIsEditModalOpen(false);
    setEditingCurriculum(null);
  }}
  rowData={editingCurriculum}   // 🔥 THIS PREFILLS DATA
  hideUI={true}
  church={church}
  selectedCurriculums={selectedCurriculums}
/>

    </>
  );
};

export default CurriculumList;
